import React from 'react'

import BootcampCard from '../../components/BootcampCard'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { minibootcampsData } from '../../data/minBootcamps'

const MiniBootCampSection = () => {
  return (
    <SectionLayout
      style={{
        background:
          'linear-gradient(126deg, rgba(97, 97, 214, 0.20) -0.76%, rgba(128, 128, 128, 0.20) 75.69%)'
      }}>
      <SectionHeader>
        <span className="text-primary">Mini</span> Bootcamp
      </SectionHeader>
      <SectionContent className="justify-center">
        {minibootcampsData.map(({ id, ...rest }) => (
          <BootcampCard key={id} {...rest} />
        ))}
      </SectionContent>
    </SectionLayout>
  )
}

export default MiniBootCampSection
